import React, { Component } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import { IStreamState, mapStreamStateToProps } from "../../redux/reducers/stream";
import { IStreamActionDispatches, mapStreamDispatchToProps } from "../../redux/actions/stream";
import { renderGridOrphans } from "../../utils";
import { getDateDisplay, getMonthDateDisplay } from "../../utils/date-utils";
import { IStream } from "../../models/stream";
import { NavLink } from "react-router-dom";
import { UINoData } from "../ui/UIComponents";
import { getContainerWidth } from "../../models/layout";
import ImageView from "../ui/Media/ImageView";
import { FileType } from "../../laco-common/base/models/IFile";
import "./StraightStreams.scss";

class StreamsPreview extends Component<IStreamActionDispatches & IStreamState & WidgetProps> {
	get streams(): IStream[] {
		return (this.props.streams || []).filter((stream: IStream) => stream.pageId === "streams");
	}

	componentDidMount() {
		this.props.loadStreams();
	}

	render() {
		let width: number = 200; // 279 / 368
		let itemsPerRow: number;
		const containerWidth: number = getContainerWidth();
		console.log("containerWidth:", containerWidth);
		switch (containerWidth) {
			case 1170: {
				width = 245;
				itemsPerRow = 5;
				break;
			}
			case 970: {
				width = 220;
				itemsPerRow = 4;
				break;
			}
			case 750: {
				itemsPerRow = 3;
				break;
			}
			case 540: {
				itemsPerRow = 2;
				break;
			}
			default: {
				itemsPerRow = 2;
				width = 145;
				// itemsPerRow = Math.min(Math.floor(getContainerWidth() / 190), 5);
			}
		}

		const itemCountToRender: number = Math.max(itemsPerRow, 2);
		const streams: IStream[] = this.streams;
		const orphansToAdd: number = itemsPerRow - streams.length;
		return (
			<div className="w-100 position-relative container-fluid">
				<div className={clsx(!this.props.isNested && "container", "section-padding")}>
					<h1 className="highlighted mb-2 text-center">Straight Streams Magazine</h1>
					<p className="mb-6 text-center px-4">
						Articles, news, events and more on all things straight from the B&W.
					</p>
					<div className="d-flex flex-row flex-wrap justify-content-around justify-content-lg-between straight-streams-container container">
						{!streams.length && <UINoData msg="No streams found" />}
						{streams.map((stream: IStream, i: number) => {
							if (i >= itemCountToRender) return null;
							const streamDate: Date = new Date(stream.stream_date);
							return (
								<NavLink to={`/straight-streams/${stream.id}`} key={i} className="scale-in-image-view">
									<div key={stream.id} style={{ maxWidth: width }} className="mb-5 align-self-start">
										<ImageView
											image={{
												filename: stream.thumbUrl,
												fileType: FileType.IMAGE,
												url: stream.thumbUrl,
											}}
											viewWidth={width}
											viewHeight={1.3 * width}
											renderContainer
										/>
										<p className="text-black color-on-hover text-center text-md1 mt-2_5 mb-1">
											{getMonthDateDisplay(streamDate)}
										</p>
									</div>
								</NavLink>
							);
						})}
						{renderGridOrphans(orphansToAdd, <div style={{ width: `${width}px` }} />)}
					</div>
					<NavLink to={`/straight-streams`} className="d-inline-block w-100 text-center mt-1">
						<button className="btn btn-primary py-2 px-4 w-60-xs">View All Streams</button>
					</NavLink>
				</div>
			</div>
		);
	}
}

export default connect<IStreamState, IStreamActionDispatches, WidgetProps>(
	mapStreamStateToProps,
	mapStreamDispatchToProps
)(StreamsPreview);
